import { FailureComponent } from './failure/failure.component';
import { SuccessComponent } from './success/success.component';
import { FormComponent } from './form/form.component';

export const InfractionEnterChildRoutes = [
  {
    path: 'success/:ofuscatedData',
    component: SuccessComponent, // another child route component that the router renders
  },
  {
    path: 'failure',
    component: FailureComponent, // another child route component that the router renders
  },
  {
    path: ':ofuscatedData',
    component: FormComponent,
  },
  {
    path: '', // child route path
    component: FormComponent, // child route component that the router renders
  },
  {
    path: '**', redirectTo: '/login',
  },
];
